import { User } from './user.model';

export class Employee extends User {

}
